import FullScreenChart from '@/components/Chart/FullScreenChart';
import useChartSeries from '@/components/Chart/hooks/useChartSeries';
import { useLightMode } from '@/pages/Markets/MarketsComponents/LightMode/contexts/LightModeContext';
import { TemplateChartSeries } from '@/pages/Markets/MarketsComponents/types';

export const FullScreenChartContent = ({
  templateChartSeries,
  tabName,
  activeTab
}: {
  activeTab: number;
  templateChartSeries?: TemplateChartSeries[];
  tabName: string;
}) => {
  const { loading, error, chartSeries } = useChartSeries(templateChartSeries, false);
  const { isLightMode } = useLightMode();

  return (
    <FullScreenChart
      key={activeTab}
      chartSeries={chartSeries}
      error={error}
      isLightMode={isLightMode}
      loading={loading}
      tabName={tabName}
    />
  );
};
